import { twMerge } from 'tailwind-merge';

import { SkeletonChips, SkeletonFilter } from '../common';
import { PitchBlock } from './PitchBlock';
import { SubstitutesBlock } from './SubstitutesBlock';

type LineupSkeletonProps = {
  className?: string;
};

export default function LineupSkeleton(props: LineupSkeletonProps) {
  const { className } = props;

  return (
    <div className={twMerge('flex flex-col gap-[12px] animate-pulse', className)}>
      <SkeletonFilter count={2} />
      <SkeletonChips />
      <PitchBlock />
      <SubstitutesBlock />
    </div>
  );
}
